import { SignatureConfig } from 'interfaces-lib';

export type Workflow = {
  workflow: string;
  config: {
    config: SignatureConfig & OutputFilename; // there will be other configs in the future
  };
};

export type WorkflowStatusMessage = {
  status: string;
};

export type WorkflowOptionsMessage = {
  key: string;
  workflows: Workflow[];
};

export type WorkflowMessage = {
  type: string;
  message: WorkflowStatusMessage | WorkflowOptionsMessage | IUploadFileResponse | any;
  workflowJobId: string;
  socketId: string;
};

export type OutputFilename = {
  originalFilename: string;
  outputFilename: string;
};

export interface IUploadFileResponse {
  data: IUploadedFileInfo;
  status: string;
}

export interface IUploadedFileInfo {
  namespace: string;
  fileName: string;
  contentType: string;
  length: number;
  path: string[];
}

export interface IS3TempBucketFileInfo extends IUploadedFileInfo {
  truncatedPath: string[];
}

export interface ISectionOutputFilename {
  originalFilename: string;
  outputFilename: string;
}

export enum MessageType {
  ERROR_EVENT = 'ErrorEvent',
  WORKFLOW_STATUS = 'WorkflowStatus',
  UPLOAD_FILE_RESPONSE = 'UploadFileResponse',
  GENERATED_OUTPUT_FILENAME = 'generatedOutputFilename',
  OPTIONS = 'options',
}

export interface IWorkflowMessageHandler {
  /**
   * Receives the messages from the workflow as it is running on the server.
   * @param message the message details
   * @returns true to close the connection to the server; false to continue receiving messages
   */
  receive(message: WorkflowMessage): boolean;
}
